import React, { useEffect } from "react";
import FHIR from "fhirclient";
import { STORAGE_KEYS } from "../../services/encrypt-decrypt";

const EpicLaunch: React.FC<any> = () => {
  useEffect(() => {
    localStorage.removeItem(STORAGE_KEYS.EPIC_INTROSPECT_URL);
    localStorage.removeItem(STORAGE_KEYS.EXPIRES_IN);
    localStorage.removeItem(STORAGE_KEYS.JWT_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.KEY_ID);
    localStorage.removeItem(STORAGE_KEYS.PUBLIC_KEY);
    localStorage.removeItem(STORAGE_KEYS.SYMMETRIC_KEY);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_EXPIRES_IN);
    FHIR.oauth2.authorize({
      clientId: process.env.REACT_APP_EPIC_CLIENT_ID,
      scope:
        "patient/*.* system/*.* user/*.* patient/*.write user/*.write patient/DocumentReference.read patient/DocumentReference.write patient/DocumentReference.cruds   launch openid fhirUser online_access offline_access",
      redirectUri: process.env.REACT_APP_EPIC_REDIRECT_URI,
    });
  }, []);

  return <div>{/* Optionally show loading or status */}</div>;
};

export default EpicLaunch;
